export { default as CryptoScamDBService } from './CryptoScamDB';
export * from './types';
